import { type TypedDocumentNode, gql } from '@apollo/client';
import type { GetBasicUserDataQuery } from '../../models/__generated__/graphql';

export const GET_BASIC_USER_DATA: TypedDocumentNode<GetBasicUserDataQuery> = gql`
  query GetBasicUserData {
    me {
      __typename
      id
      firstName
      lastName
      photoUrl
    }
  }
`;
